






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateInvoiceType, UpdateInvoiceType } from '@/api'
import { ElForm } from 'element-ui/types/form'

@Component({
  components: {},
})
export default class EditInvoiceTypeDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
      typeName: '',
      status: 1,
      remark: '',
    }
    this.show = false
  }
  private data: any = {
    typeName: '',
    status: 1,
    remark: '',
  }

  private show = false
  private isEdit = false

  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.isEdit = isEdit
    if (isEdit && data) {
      this.data = {
        id: data.id,
        typeName: data.typeName || '',
        status: data.status !== undefined ? data.status : 1,
        remark: data.remark || '',
      }
    } else {
      this.data = {
        typeName: '',
        status: 1,
        remark: '',
      }
    }
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    typeName: [this.requiredRule],
  }

  public async save() {
    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.data)
        let result = {}
        if (this.isEdit) {
          result = await UpdateInvoiceType(this.data)
        } else {
          result = await CreateInvoiceType(this.data)
        }
        if (result) {
          this.$message.success(this.isEdit ? '修改成功' : '创建成功')
          this.close()
        }
      } else {
        this.$message.error('表单存在错误，不能保存')
        return false
      }
    })
  }
}
